<template>
  <div v-cloak>
    <div class="tw-flex tw-items-center">
    <span
        v-if="poNumber"
        class="tw-inline-block tw-max-w-[150px] tw-truncate tw-align-middle"
        :title="poNumber"
      >
        <slot :po-number="poNumber">
          {{ poNumber }}
        </slot>
      </span>
    <WdsButtonGhost :class="poNumber ? '!tw-ml-1' : ''" class="!tw-inline-block" @click="open">
       <WdsIcon name="edit" :size="14"  class="tw-text-gray-700" />
    </WdsButtonGhost>
  </div>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseModal
      v-cloak
      :modal-id="`bill-${billId}`"
      :header-text="$t('Purchase order number')"
      :save-state="saveState"
      :is-open="modalOpen"
      @save="update"
      @cancel="close"
    >
      <div class="p-t-15 p-b-15">
        <input
          v-model="poNumberState"
          :disabled="loading"
          :placeholder="$t('Enter PO number')"
          title="Your purchase order number for the bill'"
          class="form-control tt-input"
        />
      </div>
    </BaseModal>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useMutation } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import { WdsButtonGhost, WdsIcon } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

interface Props {
  billId: string | number
  poNumber?: string
  showBtnWhenEmpty?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  poNumber: '',
  showBtnWhenEmpty: false,
})

const emit = defineEmits<{
  updated: [poNumber: string]
}>()

const modalOpen = ref(false)
const poNumberState = ref(props.poNumber || '')
const saveState = ref<'fresh' | 'saving' | 'saved' | 'failed'>('fresh')
const loading = ref(false)

const { mutate: updatePaymentRequest } = useMutation(
  gql`
    mutation UpdatePaymentRequestPoNumber($input: UpdatePaymentRequestInput!) {
      updatePaymentRequest(input: $input) {
        id
        purchaseOrderNumber
      }
    }
  `,
  {
    clientId: 'publicApi',
  },
)

function open() {
  modalOpen.value = false
  modalOpen.value = true
  poNumberState.value = props.poNumber || ''
}

function close() {
  modalOpen.value = false
}

async function update() {
  saveState.value = 'saving'
  loading.value = true

  try {
    const result = await updatePaymentRequest({
      input: {
        id: String(props.billId),
        purchaseOrderNumber: poNumberState.value,
      },
    })

    if (result?.data?.updatePaymentRequest) {
      saveState.value = 'saved'
      emit('updated', poNumberState.value)

      setTimeout(() => {
        close()
      }, 1000)
    } else {
      saveState.value = 'failed'
    }
  } catch (error: any) {
    saveState.value = 'failed'
  } finally {
    loading.value = false
    setTimeout(() => {
      saveState.value = 'fresh'
    }, 1000)
  }
}
</script>
